import { connect } from 'react-redux'
import { SiteRouteProps } from '../Router/Router'

import { SiteMaster, StateProps, DispatchProps } from './SiteMaster'
import { saveSiteConfig } from './actions/UpdateConfig'
import { RootState } from '../../reducers/root-reducer'
import { withRouter } from 'react-router'
import { MarketConfigState } from '../../reducers/SiteConfig'
import SiteConfig from '../../model/SiteConfig'
import * as _ from 'lodash'

const mapStateToProps = ({ siteConfig }: RootState, ownProps: SiteRouteProps): StateProps => {
  const modePart = ownProps.match.path.split('/', 3)[2]
  console.log("modePart = [" + modePart + "]");
  var anySitesLoading = false;
  var allSitesLoading = true;
  var siteConfigs : SiteConfig[] = [];
  siteConfig.markets.forEach((value: MarketConfigState) => {
    if(value.sitesLoading) anySitesLoading = true;
    if(!value.sitesLoading) allSitesLoading = false;
    if(value.siteConfigs) siteConfigs = _.union(siteConfigs, value.siteConfigs)
  });
  return {
    mode: modePart === "downtime" || modePart === "configuration" ? modePart : "downtime",
    siteConfigs: siteConfigs,
    anySitesLoading: anySitesLoading,
    allSitesLoading: allSitesLoading,
    siteConfig:
      siteConfigs &&
      siteConfigs.find(s => s.key === ownProps.match.params.siteKey),
    messageService: ownProps.messageService
  }
}

const mapDispatchToProps: DispatchProps = {
  siteConfigSave: saveSiteConfig
}

export const SiteMasterContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SiteMaster)
)
